import { SET_UPLOAD_STATE } from '../constants/actionTypes'

export const setUploadState = (uploadState) => ({
  type: SET_UPLOAD_STATE,
  uploadState,
})
